import { render, staticRenderFns } from "./digitalVillage.vue?vue&type=template&id=ad4e6e4e&scoped=true"
import script from "./digitalVillage.vue?vue&type=script&lang=js"
export * from "./digitalVillage.vue?vue&type=script&lang=js"
import style0 from "./digitalVillage.vue?vue&type=style&index=0&id=ad4e6e4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4e6e4e",
  null
  
)

export default component.exports